import _has from "lodash/has";
import _isEmpty from "lodash/isEmpty";
import { REALM, Realm } from "../../constants";
import { CampaignCode, SubscriptionType, SubscriptionWithGetIT } from "../../models";

export const offeringCodesToDoubleSpeed: SubscriptionType[] = [
    /*
  "TELIA_MOBIL_X_NORMAL",
  "TELIA_MOBIL_X_RASK",
  "TELIA_MOBIL_X_UNG",
  */
];

type AdjustedSpeed = Pick<SubscriptionWithGetIT, "dataMaxSpeed" | "doubleSpeed">;

const getAdjustedSpeedObject = (amount: number, newAmount: string, unit = "Mbit/s"): AdjustedSpeed => ({
    dataMaxSpeed: {
        amount,
        unit,
    },
    doubleSpeed: newAmount,
});

export const campaignAdjustedSpeeds: { [key in SubscriptionType]?: AdjustedSpeed } = {};

export const campaignAdjustedSpeedsTeliaSamlet: { [key in SubscriptionType]?: AdjustedSpeed } = {
    TELIA_X_START: getAdjustedSpeedObject(10, "20"),
    TELIA_X_BASIC: getAdjustedSpeedObject(220, "440"),
    TELIA_X_START_2025: getAdjustedSpeedObject(10, "20"),
    TELIA_X_START_2026: getAdjustedSpeedObject(10, "20"),
    TELIA_X_START_2027: getAdjustedSpeedObject(10, "20"),
    TELIA_X_BASIC_2025_2: getAdjustedSpeedObject(250, "500"),
    TELIA_X_BASIC_2026: getAdjustedSpeedObject(250, "500"),
    TELIA_X_BASIC_2027: getAdjustedSpeedObject(250, "500"),
    TELIA_MOBIL_X_UNG: getAdjustedSpeedObject(220, "440"),
    TELIA_MOBIL_X_UNG_2026: getAdjustedSpeedObject(220, "440"),
};

export const offeringCodesToDoubleData: { [key in SubscriptionType]?: string } = {
    // Old
    TELIA_MOBIL_02GB: "6",
    TELIA_MOBIL_06GB: "16",
    TELIA_MOBIL_10GB: "30",
    TELIA_MOBIL_15GB: "40",
    // New
    TELIA_MOBIL_03GB: "6",
    TELIA_MOBIL_03GB_2027: "6",
    TELIA_MOBIL_15GB_2027: "30",
    TELIA_MOBIL_05GB: "10",
    TELIA_MOBIL_05GB_2025: "10",
    TELIA_MOBIL_05GB_2026: "10",
    TELIA_MOBIL_05GB_2025_2: "10",
    TELIA_MOBIL_08GB: "16",
    TELIA_MOBIL_10GB_UNG: "20",
    TELIA_MOBIL_10GB_UNG_2026: "20",
    TELIA_MOBIL_15GB_02: "30",
    TELIA_MOBIL_20GB: "40",
    // Athena
    TELIA_MOBIL_10GB_02: "20",
    TELIA_MOBIL_10GB_2025: "20",
    TELIA_MOBIL_10GB_2026: "20",
    TELIA_MOBIL_10GB_2025_2: "20",
    TELIA_JUNIOR_01GB: "2",
    TELIA_JUNIOR_03GB: "10",
    TELIA_JUNIOR_10GB_2026: "20",
    // Summer Campaign
    "TELIA_JUNIOR_01GB+PROMO_JR06_50_2026": "2",
    "TELIA_JUNIOR_10GB_2026+PROMO_JR06_50_2026": "20",
};

export const offeringCodesToCampaign: { [key in SubscriptionType]?: CampaignCode } = {
    TELIA_MOBIL_X_NORMAL: "COM12PURP10",
    TELIA_MOBIL_X_RASK: "COM12PURP10",
    TELIA_MOBIL_X_MAX: "COM12PURP10",
    TELIA_MOBIL_02GB: "COM12PURP10",
    TELIA_MOBIL_06GB: "COM12PURP10",
    TELIA_MOBIL_10GB: "COM12PURP10",
    TELIA_MOBIL_15GB: "COM12PURP10",
    TELIA_MOBIL_03GB: "COM12PURP10",
    TELIA_MOBIL_05GB: "COM12PURP10",
    TELIA_MOBIL_08GB: "COM12PURP10",
    TELIA_MOBIL_15GB_02: "COM12PURP10",
    TELIA_MOBIL_20GB: "COM12PURP10",
    TELIA_MOBIL_03GB_2027: "COM12PURP10",
    TELIA_MOBIL_15GB_2027: "COM12PURP10",
    // Old
    TELIA_X_BASIC_2025_2: "COM12PURP20",
    TELIA_X_BASIC_2026: "COM12PURP20",
    TELIA_X_BASIC_2027: "COM12PURP20",
    TELIA_X_MAX_2025: "COM12PURP20",
    TELIA_X_MAX_2026: "COM12PURP20",
    TELIA_X_MAX_2027: "COM12PURP20",
    TELIA_X_MAX_PLUS_2025: "COM12PURP20",
    TELIA_X_MAX_PLUS_2026: "COM12PURP20",
    TELIA_X_MAX_PLUS_2027: "COM12PURP20",
    TELIA_X_START_2025: "COM12PURP20",
    TELIA_X_START_2026: "COM12PURP20",
    TELIA_X_START_2027: "COM12PURP20",
    TELIA_MOBIL_10GB_2025: "COM12PURP20",
    TELIA_MOBIL_10GB_2026: "COM12PURP20",
    TELIA_MOBIL_10GB_2025_2: "COM12PURP20",
    TELIA_MOBIL_X_UNG_2025_2: "COM12PURP20",
    TELIA_MOBIL_X_UNG_2026: "COM12PURP20",
    // New
};

export const showPricesWithBinding = (querySearch?: Record<string, string | undefined>): boolean =>
    querySearch?.avtaletid === "true";

export const setBindingOfferData = (subscriptions: SubscriptionWithGetIT[]): SubscriptionWithGetIT[] =>
    subscriptions.map((subscription) => {
        let addons = {};
        if (_has(offeringCodesToCampaign, subscription.offeringCode)) {
            addons = {
                // icim: offeringCodesToCampaign[subscription.offeringCode],
                // This is the new full price multiplier,
                // so 0.8 equals 80% of full price, ie 20% discount
                icim: offeringCodesToCampaign[subscription.offeringCode],
                priceMultiplier: 0.8,
            };
        }

        return {
            ...subscription,
            ...addons,
        };
    });

export const setAdjustedSpeedsData = (
    subscriptions: SubscriptionWithGetIT[],
    showExistingGetOffer?: boolean,
): SubscriptionWithGetIT[] =>
    subscriptions.map((subscription) => {
        let addons: Partial<SubscriptionWithGetIT> = {};
        const dataSet = showExistingGetOffer ? campaignAdjustedSpeedsTeliaSamlet : campaignAdjustedSpeeds;

        if (_has(dataSet, subscription.offeringCode)) {
            addons = dataSet[subscription.offeringCode] || {};
        }

        return {
            ...subscription,
            ...addons,
        };
    });

export const setExistingGetOfferData = (subscriptions: SubscriptionWithGetIT[]): SubscriptionWithGetIT[] =>
    subscriptions.map((subscription) => {
        const addons: Partial<SubscriptionWithGetIT> = {};

        if (offeringCodesToDoubleData[subscription.offeringCode]) {
            addons.customerTypeGet = "existing";
            addons.doubleData = offeringCodesToDoubleData[subscription.offeringCode];
        }

        if (offeringCodesToDoubleSpeed.includes(subscription.offeringCode)) {
            addons.customerTypeGet = "existing";
            addons.doubleSpeed = `${(subscription.dataMaxSpeed?.amount || 0) * 2}`;
        }

        return {
            ...subscription,
            ...addons,
        };
    });

const showExistingGetOffer = (querySearch?: Record<string, string | undefined>): boolean => querySearch?.ts === "true";

export const showExistingOffer = (
    realm: Realm,
    querySearch: Record<string, string | undefined> | undefined,
    customerTypeGet: string,
): {
    showExistingGetOffer: boolean;
} => {
    let shouldShowExistingGetOffer = false;

    if (realm === REALM.B2B) {
        return {
            showExistingGetOffer: false,
        };
    }

    switch (true) {
        case showExistingGetOffer(querySearch):
            shouldShowExistingGetOffer = true;
            break;
        default:
            shouldShowExistingGetOffer = customerTypeGet === "existing";
            break;
    }

    return {
        showExistingGetOffer: shouldShowExistingGetOffer,
    };
};

type UpdateSubscriptionsParams = {
    hiddenSubscriptions: SubscriptionType[];
    isUnder30: boolean;
    shouldShowAdjustedSpeeds?: boolean;
    shouldShowBinding?: boolean;
    shouldShowExistingGetOffer?: boolean;
    shouldShowOnlyUnder30?: boolean;
    shouldShowPersonalFamilyDiscount?: boolean;
    showHiddenSubscriptions?: boolean;
    subscriptions: SubscriptionWithGetIT[];
};

export const updateSubscriptions = ({
    subscriptions,
    shouldShowExistingGetOffer,
    shouldShowAdjustedSpeeds,
    shouldShowBinding,
    shouldShowOnlyUnder30,
    isUnder30,
    showHiddenSubscriptions,
    hiddenSubscriptions,
}: UpdateSubscriptionsParams): SubscriptionWithGetIT[] => {
    let updatedSubscriptions = subscriptions;

    if (!showHiddenSubscriptions && !_isEmpty(hiddenSubscriptions)) {
        updatedSubscriptions = updatedSubscriptions.map((sub) => ({
            ...sub,
            isHidden: hiddenSubscriptions.includes(sub.offeringCode),
        }));
    }

    if (shouldShowExistingGetOffer) {
        updatedSubscriptions = setExistingGetOfferData(updatedSubscriptions);
    }

    if (shouldShowAdjustedSpeeds) {
        updatedSubscriptions = setAdjustedSpeedsData(updatedSubscriptions, shouldShowExistingGetOffer);
    }

    if (shouldShowBinding) {
        updatedSubscriptions = setBindingOfferData(updatedSubscriptions);
    }

    if (isUnder30) {
        updatedSubscriptions = updatedSubscriptions.filter(
            (sub) =>
                ![
                    "TELIA_X_BASIC_2025",
                    "TELIA_X_BASIC_2026",
                    "TELIA_MOBIL_10GB_2026",
                    "TELIA_MOBIL_10GB_2025",
                ].includes(sub.offeringCode),
        );
    } else {
        updatedSubscriptions = updatedSubscriptions.filter(
            (sub) =>
                ![
                    "TELIA_MOBIL_X_UNG",
                    "TELIA_MOBIL_X_UNG_2025_2",
                    "TELIA_MOBIL_X_UNG_2026",
                    "TELIA_MOBIL_10GB_UNG",
                    "TELIA_MOBIL_10GB_UNG_2026",
                ].includes(sub.offeringCode),
        );
    }

    if (shouldShowOnlyUnder30) {
        updatedSubscriptions = updatedSubscriptions.filter((sub) => sub.isUngSubscription || sub.isBarnSubscription);
    }

    return updatedSubscriptions;
};

/**
 * There are some paths to getting default offering code
 * 1) We try to use query param abonnement=XXX
 * 2) If not, we try to use defaultOfferingCode from CF
 * 3) If that doesn't exists either, we default to first subscription.
 */
export const getInitialSelectedSubscription = (
    subscriptions: SubscriptionWithGetIT[],
    defaultOfferingCode?: string,
    currentSearch?: Record<string, string | undefined>,
): string => {
    const queryOfferingCode = currentSearch?.abonnement as string;
    const queryOfferingCodeExists = !!subscriptions.find(
        (subscription) => subscription.offeringCode === queryOfferingCode,
    );

    if (queryOfferingCodeExists) {
        return queryOfferingCode;
    }

    return subscriptions.find((subscription) => subscription.offeringCode === defaultOfferingCode)?.offeringCode || "";
};
